import type { ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { NotificationStatusBarContainer } from './NotificationStatusBarContainer'

/**
 * Mounts the app's single toast region (TO-644). It is portalled into
 * `document.body` so every route shows toasts — including shell-less pages
 * outside `Layout` — at one fixed bottom-right position above page content.
 * Mount once, at the app root; screens fire toasts with `useToast`.
 */
export function ToastProvider({ children }: { children: ReactNode }) {
	return (
		<>
			{children}
			{createPortal(
				<div className="fixed bottom-ds-4 right-ds-4 z-50 w-80 max-w-[calc(100vw-2rem)]">
					<NotificationStatusBarContainer />
				</div>,
				document.body,
			)}
		</>
	)
}
